import React, { Fragment, useContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import NavBar from "./components/layout/NavBar";
import "./App.scss";
import ClientProfiles from "./components/customer/ClientProfiles";
import CustomerForm from "./components/customer/CustomerForm";
import Loader from "./components/common/Loader";
import FilingMasterForm from "./components/filing-master/FilingMasterForm";
import FilingMasterList from "./components/filing-master/FilingMasterList";
import PostAwardFilingMasterList from "./components/PostAwards/PostAwardFilingMaster/PostAwardFilingMasterList";
import ApprovalList from "./components/filing-master/ApprovalList";
import ClientFilingMasterList from "./components/client-filing-master/ClientFilingMasterList";
import BusinessCategory from "./components/category/BusinessCategory";
import ProgramNames from "./components/PostAwards/ProgramNames";
import ApprovalConfig from "./components/customer/ApprovalConfig";
import PostAwardApproverConfiguration from "./components/PostAwards/PostAwardApproverConfiguration";
import PostAwardApprovalList from "./components/PostAwards/PostAwardApprovalList";
import PostAwardMasterForm from "./components/PostAwards/post-award-form/PostAwardMasterForm";
import AddFilingList from "./components/dev/addfiling/AddFilinglist";
import AuthContext from "./context/auth/AuthContext";
import ClientFilingMasterApprovalList from "./components/client-filing-master/ClientFilingMasterApprovalList";
import PostAwardClientFilingMasterApprovalList from "./components/PostAwards/PostAwardClientFilingMasterApprovall/PostAwardClientFilingMasterApprovalList";
import ClientFilingTrackerList from "./components/client-filing-tracker/ClientFilingTrackerList";
import { PageLayout } from "./ui-components/PageLayout";
import Reminder from "./components/client-filing-master/Reminder";
import Notification from "./components/dev/Notification";
import RollOverFilings from "./components/dev/RollOverFilings";
import PostAwardRollOverFilings from "./components/dev/PostAwardRollOverFilings";
import UserRoleSetup from "./components/client-filing-master/UserRoleSetup";
import ClientFilingMasterReferenceDocuments from "./components/client-filing-master/ClientFilingMasterReferenceDocuments";
import FilingMasterReferenceDocument from "./components/filing-master/FilingMasterReferenceDocument";
import FilingMasterApprovalHistory from "./components/filing-master/FilingMasterApprovalHistory";
import usePermission from "./usePermission";
import UnAuthorized from "./components/common/UnAuthorized";
import PageNotFound from "./components/common/PageNotFound";
import NotificationConfiguration from "./components/client-filing-master/NotificationConfiguration";
import AddFilingPostAwardlist from "./components/PostAward/AddFilingPostAwardlist";
import TrackerCalendarView from "./components/calendar/TrackerCalendarView";
import SnackbarComponent from "./components/common/Snackbar";
import LandingPage from "./components/common/LandingPage";
import BrandingConfiguration from "./components/client-filing-master/BrandingConfiguration";
import { useCommonDetailsContext } from "./context/Common/common";

function App() {
  const authContext = useContext(AuthContext);
  const { loadUser, portalUser, isPortalAuthenticated, isAuthenticated } =
    authContext;

  const [userChecked, setUserChecked] = useState(false);

  const fetchUserInfo = async () => {
    try {
      if (loadUser) await loadUser();
      // console.log("USER INFO LOADED", tmpUser);
      setUserChecked(true);
      // setAppUser(tmpUser);
    } catch (err) {
      // console.log("USER INFO NOT AVAILABLE");
      setUserChecked(false);
    }
  };

  useEffect(() => {
    if (!portalUser) {
      fetchUserInfo();
    }
  }, []);

  useEffect(() => {
    if (portalUser) {
      // console.log("USER LOADED", portalUser);
    }
  }, [portalUser]);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     console.log("User has access");
  //   } else {
  //     console.log("User does not have access");
  //   }

  //   return () => {
  //     setAuthorized && setAuthorized(false);
  //   };
  // }, [isAuthenticated]);

  return (
    <PageLayout>
      <Grid container justifyContent="center">
        <Pages isAuthorized={isPortalAuthenticated && isAuthenticated} />
      </Grid>
    </PageLayout>
  );
}
const IsDisabled = (menuName: any) => {
  // console.log("manimenu", menuName);

  return !usePermission(menuName, "viewPage");
};
function Pages(props: any) {
  const authContext = useContext(AuthContext);
  const { roleType, authUser, roleDetails } = authContext;
  const { validateParentData } = useCommonDetailsContext();
  const isAdmin = Array.isArray(roleType) ? roleType.includes("Admin") : false;
  const isAdminPostaward = Array.isArray(roleType)
    ? roleType.includes("Admin-PostAward")
    : false;
  const isBrandingRoleIncludes = Array.isArray(roleType)
    ? roleType.some((role: string) =>
      [
        "Admin",
        "Admin-PostAward",
        "ClientAdmin",
        "ClientAdmin-PostAward",
        "HierarchyAdmin",
        "HierarchyAdmin-PostAward",
      ].includes(role)
    )
    : roleType
    ? [
      "Admin",
      "Admin-PostAward",
      "ClientAdmin",
      "ClientAdmin-PostAward",
      "HierarchyAdmin",
      "HierarchyAdmin-PostAward",
    ].includes(roleType)
    : false;
  const hasParentCustomerType = Array.isArray(roleDetails) && roleDetails.some(
    (item: any) =>
      item?.customerType?.toLowerCase() === "parent" ||
      item?.clientType?.toLowerCase() === "parent"
  );
  const isSingleParent = Boolean(validateParentData?.isSingleParent ?? validateParentData?.ifSingleParent);
  const showBrandingPage = Boolean(
    (roleType && (roleType.includes("Admin") || roleType.includes("Admin-PostAward"))) ||
    (isBrandingRoleIncludes && hasParentCustomerType)
  );
  const [isAddClientFiling, setIsAddClientFiling] = useState(false);
  // console.log("Permission-check", "ADMIN", isAdmin, "isAdminPostaward", isAdminPostaward);
  const handleAddClientSpecificFiling = (value: boolean) => {
    setIsAddClientFiling(value);
  };

  return (
    <Fragment>
      {props.isAuthorized ? (
        // <Grid
        //   container
        //   spacing={0}
        //   columns={24}
        //   sx={{
        //     height: "100%",
        //     width: "100%",
        //     background: "background.default",
        //   }}
        // >
        <div style={{ width: "100%" }}>
          <SnackbarComponent />
          <Routes>
            <Route
              path="/customer"
              element={
                IsDisabled("AddNewClient") ? <UnAuthorized /> : <CustomerForm />
              }
            />
            <Route
              path="/filing-master-list"
              element={
                IsDisabled("MasterFilingList") ? (
                  <UnAuthorized />
                ) : (
                  <FilingMasterList />
                )
              }
            />
            <Route
              path="/postaward-filing-master-list"
              element={
                IsDisabled("PostAwardMasterList") ? (
                  <UnAuthorized />
                ) : (
                  <PostAwardFilingMasterList />)
              }
            />
            <Route
              path="/postaward-approval-list"
              element={
                IsDisabled("PostAwardMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <PostAwardApprovalList />
                )
              }
            />
            <Route
              path="/postaward-master-form"
              element={

                IsDisabled(isAddClientFiling ? "AddClientFiling" : "AddPostAwardMaster") ? (
                  < UnAuthorized />
                ) : (
                  <PostAwardMasterForm />
                )
              }
            />
            <Route
              path="/filing-master"
              element={
                IsDisabled(
                  isAddClientFiling ? "AddClientFiling" : "AddFilingMaster"
                ) ? (
                  <UnAuthorized />
                ) : (
                  <FilingMasterForm />
                )
              }
            />
            <Route
              path="/filing-master-approval-list"
              element={
                IsDisabled("FilingMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <ApprovalList />
                )
              }
            />
            <Route
              path="/client-filing-master-approval-list"
              element={
                IsDisabled("ClientFilingMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <ClientFilingMasterApprovalList />
                )
              }

            />
            <Route
              path="/PostAwardClientfilingMasterApprovalList"
              element={
                IsDisabled("PostAwardClientApproval") ? (
                  <UnAuthorized />
                ) : (
                  <PostAwardClientFilingMasterApprovalList />
                )
              }
            />
            <Route
              path="/client-filing-master-list/:clientId?"
              element={
                IsDisabled("ClientFilingMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <ClientFilingMasterList />
                )
              }
            />
            <Route
              path="/client-filing-tracker-list/:clientId?"
              element={
                IsDisabled("ViewClientFilingTracker") ? (
                  <UnAuthorized />
                ) : (
                  <ClientFilingTrackerList
                    onAddClientSpecificFilingClick={(value: boolean) =>
                      handleAddClientSpecificFiling(value)
                    }
                  />
                )
              }
            />
            <Route
              path="/calendar/:clientId?"
              element={<TrackerCalendarView onAddClientSpecificFilingClick={(value: boolean) =>
                handleAddClientSpecificFiling(value)
              } />}
            />
            <Route
              path="/business-category"
              element={
                IsDisabled("BusinessCategory") ? (
                  <UnAuthorized />
                ) : (
                  <BusinessCategory />
                )
              }
            />
            <Route path="/ProgramNames" element={<ProgramNames />} />
            <Route
              path="/add-filings/:clientId?"
              element={
                IsDisabled("AddClientFiling") ? (
                  <UnAuthorized />
                ) : (
                  <AddFilingList />
                )
              }
            />
            <Route
              path="/add-filing-postaward/:clientId?"
              element={
                IsDisabled("PostAwardDefferedList") ? (
                  <UnAuthorized />
                ) : (
                  <AddFilingPostAwardlist />
                )
              }
            />
            <Route
              path="/ApprovalConfig"
              element={
                IsDisabled("ApprovalConfiguration") ? (
                  <UnAuthorized />
                ) : (
                  <ApprovalConfig />
                )
              }
            />
            <Route
              path="/PostAwardApproverConfiguration"
              element={<PostAwardApproverConfiguration />}
            />
            <Route path="/notification" element={<Notification />} />
            <Route
              path="/ClientFilingMasterReferenceDocuments"
              element={
                IsDisabled("ClientFilingMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <ClientFilingMasterReferenceDocuments />
                )
              }
            />
            <Route
              path="/FilingMasterReferenceDocument"
              element={
                IsDisabled("FilingMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <FilingMasterReferenceDocument />
                )
              }
            />
            <Route
              path="/FilingMasterApprovalHistory"
              element={
                IsDisabled("FilingMasterApproval") ? (
                  <UnAuthorized />
                ) : (
                  <FilingMasterApprovalHistory />
                )
              }
            />
            <Route
              path="/reminder"
              element={IsDisabled("setting") ? <UnAuthorized /> : <Reminder />}
            />{" "}
            <Route
              path="/notificationConfiguration"
              element={
                IsDisabled("setting") ? (
                  <UnAuthorized />
                ) : (
                  <NotificationConfiguration />
                )
              }
            />{" "}
            <Route
              path="/branding-configuration"
              element={
                showBrandingPage ? (
                  <BrandingConfiguration />
                ) : (
                  <UnAuthorized />
                )
              }
            />
            <Route
              path="/reminder"
              element={IsDisabled("setting") ? <UnAuthorized /> : <Reminder />}
            />{" "}
            <Route
              path="/user-role-setup"
              element={
                IsDisabled("userRole") ? <UnAuthorized /> : <UserRoleSetup />
              }
            />
            <Route
              path="/rollOverFilings"
              element={
                isAdmin || isAdminPostaward ? (
                  <RollOverFilings />
                ) : (
                  <UnAuthorized />
                )
              }
            />
            {/* <Route
              path="/postawardrollOverFilings"
              element={
                IsDisabled("rollOver") ? <UnAuthorized /> : <PostAwardRollOverFilings />
              }
            /> */}
            <Route
              path="/"
              element={
                IsDisabled("ClientProfile") ? (
                  <UnAuthorized />
                ) : (
                  <ClientProfiles />
                )
              }
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
        // </Grid>
      ) : (
        <LandingPage />
      )}
    </Fragment>
  );
}

export default App;
